import * as React from 'react';
import styles from './ButtonGroup.module.css';
import {SharedComponentProps} from '../../types/SharedComponentProps';
import RenderHelpers from '../../../shared-ui/helpers/RenderHelpers';

interface ButtonGroupProps extends SharedComponentProps {
  align?: 'left' | 'right';
  minWidth?: number;
  gap?: number;
  children: React.ReactNode;
}

export const ButtonGroup = (props: ButtonGroupProps) => {
  const {align = 'right', minWidth = 120, gap = 8} = props;

  const style = {
    '--button-group-min-width': `${minWidth}px`,
    '--button-group-gap': `${gap}px`,
    ...props.style,
  } as React.CSSProperties;

  return (
    <div
      className={RenderHelpers.classes(styles.buttonGroup, props.className)}
      style={style}
      data-align={align}
    >
      {props.children}
    </div>
  );
};
